import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FomanticUIModule } from 'ngx-fomantic-ui';
import { SwiperModule } from 'ngx-swiper-wrapper';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatExpansionModule } from '@angular/material/expansion';

import { LocationDetailsRoutingModule } from './location-details-routing.module';
import { UiModule } from '@monorepo/ui';
import { TrendingScreensModule } from '../trending-screens/trending-screens.module';
import { TrendingCategoriesModule } from '../trending-categories/trending-categories.module';
import { PriceCalculatorModule } from '../price-calculator/price-calculator.module';

import { LocationDetailContainerComponent } from './components/location-detail-container/location-detail-container.component';
import { BookScreenComponent } from './components/book-screen/book-screen.component';
import { ListingOwnerComponent } from './components/listing-owner/listing-owner.component';
import { ListingImagesComponent } from './components/listing-images/listing-images.component';
import { ListingHoursComponent } from './components/listing-hours/listing-hours.component';
import { ListingReviewsComponent } from './components/listing-reviews/listing-reviews.component';
import { ListingCommentsComponent } from './components/listing-comments/listing-comments.component';

@NgModule({
  declarations: [
    LocationDetailContainerComponent,
    BookScreenComponent,
    ListingOwnerComponent,
    ListingImagesComponent,
    ListingHoursComponent,
    ListingReviewsComponent,
    ListingCommentsComponent,
  ],
  imports: [
    CommonModule,
    LocationDetailsRoutingModule,
    FomanticUIModule,
    FormsModule,
    SwiperModule,
    MatExpansionModule,
    MatCheckboxModule,
    UiModule,
    TrendingCategoriesModule,
    TrendingScreensModule,
    PriceCalculatorModule,
  ],
})
export class LocationDetailsModule {}
